module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAKCAYAAABi8KSDAAAAAXNSR0IArs4c6QAAACFJREFUGBljZFjEsYrh//9QBkKAkSmMiZAaZPlRxfQJDQD4yQQU6WQ0pQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/Hcp-icon/legend/transmitter.png
// module id = siL9
// module chunks = 38